import { FocusEvent, useCallback, useEffect, useState } from 'react';
import TextField, { TextFieldVariants, BaseTextFieldProps } from '@mui/material/TextField';

import { FCX } from '@core/models';

const REGEXP = /^([0-9]+)?(\.)?([0-9]{1,2})?$/;

const FloatInput: FCX<{
    value: string;
    setValue: (_value: string) => void;
    onBlur?: BaseTextFieldProps['onBlur'];
    placeholder?: string;
    label?: string;
    isDisabled?: boolean;
    isSmall?: boolean;
    variant?: TextFieldVariants;
    onKeyDown?: BaseTextFieldProps['onKeyDown'];
}> = ({
    value,
    setValue,
    onBlur,
    placeholder,
    isDisabled = false,
    isSmall = false,
    variant,
    label,
    onKeyDown,
    style
}) => {
    const [localValue, setLocalValue] = useState(value);

    const onChange = useCallback(
        (val: string | undefined) => {
            if (val === undefined) {
                return;
            }

            if (!REGEXP.test(val) && val !== '') {
                return;
            }
            setLocalValue(val.replace(/\.+/g, '.'));
        },
        [],
    );

    useEffect(() => {
        setLocalValue(value);
    }, [value]);

    const handleBlur = useCallback(
        (event: FocusEvent<HTMLInputElement>) => {
            setValue(localValue.replace(/\.{2,}/g, '.'));
            if (onBlur) onBlur(event);
        },
        [localValue, setValue, onBlur],
    );

    return (
        <TextField
            value={localValue}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            disabled={isDisabled}
            classes={{
                root: 'FloatInput',
            }}
            InputProps={{
                classes: !variant
                    ? {
                        root: `${isSmall ? 'FloatInput__root--small' : 'FloatInput__root'}`,
                        input: 'FloatInput__input',
                    }
                    : undefined,
            }}
            fullWidth
            variant={variant}
            label={label}
            onBlur={handleBlur}
            onKeyDown={onKeyDown}
            inputProps={{
                style,
            }}
        />
    );
};

export default FloatInput;
